import { isMasurenPortal } from '~/utils/isMasurenPortal'

function stubGtmModules () {
  return new Proxy({}, {
    get: () => new Proxy({}, {
      get: () => () => {}
    })
  })
}

// The real modules pull in @gtm-support/vue-gtm. Masuren does not download them.
export default defineNuxtPlugin(async () => {
  const { currentPortal } = usePortals()
  if (isMasurenPortal(currentPortal.value?.portal?.portal)) {
    return {
      provide: {
        gtmModules: stubGtmModules()
      }
    }
  }

  const { createGtmModules } = await import('~/repositories/gtm/createGtmModules')
  return {
    provide: {
      gtmModules: createGtmModules()
    }
  }
})
